<template>
  <teleport to="body">
    <notifications
      :width="isMobile ? '100%' : '320px'"
      :position="isMobile ? 'top right' : 'bottom right'"
      :class="!isMobile && 'mb-4 mr-6'"
    >
      <template #body="{ item, close }">
        <div
          class="notification px-3 py-6 lg:py-4 lg:my-2 lg:rounded-lg text-white"
          :class="themes[item.type]"
        >
          <div class="flex justify-between items-start space-x-3">
            <span class="mr-auto leading-tight">{{ $t(item.text) }}</span>
            <button
              @click="close"
              class="focus:outline-none inline-flex flex-shrink-0"
            >
              <img
                src="@/assets/images/base/icons/close-circle-white.svg"
                width="28"
                height="28"
                loading="lazy"
                alt=""
              />
            </button>
          </div>
        </div>
      </template>
    </notifications>
  </teleport>
</template>

<script>
import isMobile from "@/mixins/isMobile";

export default {
  name: "LayoutsNotification",
  mixins: [isMobile],
  data() {
    return {
      themes: {
        info: "bg-primary-100",
        success: "bg-success-100",
        danger: "bg-danger-100",
      },
    };
  },
};
</script>
